import React from "react";
import {  useSelector } from "react-redux";
import { AppState } from "../config/redux/reducers";
import {
  fetchVTStatuses,
  vtOrderReplanning,
  fetchDeliveryReasons,
} from "./redux/valetTrolleySlice";
import { createConsignmentReplanningPayload } from "../mocks/SharedTransform/response.transforms";
import OrderDetailsEdit from "SharedComponent/components/orderDetailsEdit";

interface ValetTrolleyOrderDetailsEditProps {
  open: boolean;
  consignment: any;
  isExpress?: any;
  closePopup: () => void;
}

const ValetTrolleyOrderDetailsEdit = (
  props: ValetTrolleyOrderDetailsEditProps
) => {

  const { open, consignment, closePopup } = props;

  const {
    vtStatuses,
    deliveryReasons,
    reasonsDropdownList,
    vtReplanningConsignmentSuccess,
    consignmentDataAfterReplanning,
    deliverySlotListVT,
  } = useSelector((state: AppState) => state.valetTrolley);

  return (
    <OrderDetailsEdit
     open={open}
     consignment={consignment}
     closePopup={closePopup}
     reduxStates={{
       statuses: vtStatuses,
       deliveryReasons,
       reasonsDropdownList,
       replanningConsignmentSuccess: vtReplanningConsignmentSuccess,
       consignmentDataAfterReplanning,
       deliverySlotList:deliverySlotListVT,
     }}
     transforms={{
       createOrderReplanningPayload: createConsignmentReplanningPayload,
     }}
     actions={{
       orderReplanning: vtOrderReplanning, 
       fetchStatuses: fetchVTStatuses,
       fetchDeliveryReasons
     }}  />
 
   );
};

export default ValetTrolleyOrderDetailsEdit;
